<template>
  <v-col cols="12">
    <p>Default profile name</p>
    <v-text-field v-model="defaultProfileName.value" placeholder="Name"></v-text-field>
    <p></p>
    <v-toolbar color="grey lighten-3">
      <v-toolbar-title>Profiles </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn small fab color="primary" @click="onAddProfile">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-expansion-panels>
      <draggable
        v-model="profileList"
        @start="drag = true"
        @end="
          drag = false;
          onDragProfileEnd();
        "
        handle=".draghandle"
        style="width: 100%"
      >
        <transition-group>
          <v-expansion-panel v-for="(profile, profileIndex) in profileList" :key="profile.id">
            <v-expansion-panel-header>
              <template v-slot:default="{ open }">
                <v-fade-transition leave-absolute>
                  <v-row no-gutters align="center">
                    <v-col>
                      <v-btn icon class="draghandle">
                        <v-icon>mdi-drag-horizontal</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="9">
                      <span v-if="open" key="0">
                        {{ profile.name.value }}
                      </span>
                      <span v-else key="1">
                        {{ profile.name.value }}
                      </span>
                    </v-col>

                    <v-spacer> </v-spacer>
                    <v-col cols="1">
                      <v-btn icon>
                        <v-icon @click="onDeleteProfile(profile.id)">mdi-close-thick</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-fade-transition>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-text-field v-model="profile.name.value" label="Name" placeholder="Profile name"></v-text-field>

              <v-toolbar color="grey lighten-3">
                <v-toolbar-title>Categories</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn small fab color="primary" @click="onAddProfileCategory(profile.id)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-toolbar>
              <v-expansion-panels>
                <v-expansion-panel v-for="(profileCategory, index) in profile.categories" :key="index">
                  <v-expansion-panel-header>
                    <template v-slot:default="{ open }">
                      <v-fade-transition leave-absolute>
                        <v-row no-gutters>
                          <v-col cols="3">
                            <v-chip v-if="open" key="0" small color="primary">
                              {{ profileCategory.id }}
                            </v-chip>
                            <v-chip v-else key="1" small color="primary"> {{ profileCategory.id }} </v-chip>
                          </v-col>

                          <v-col cols="8">
                            <v-chip
                              v-for="(chipCategories, idx) in profileCategory.values"
                              :key="idx"
                              small
                              color="primary"
                            >
                              {{ chipCategories.id }}
                            </v-chip>
                          </v-col>

                          <v-spacer> </v-spacer>
                          <v-col cols="1">
                            <v-btn icon>
                              <v-icon @click="onDeleteProfileCategory(index, profileIndex)">mdi-close-thick</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-fade-transition>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p></p>

                    <v-combobox v-model="profileCategory.id" :items="getCategoryClass()" chips></v-combobox>
                    <p></p>
                    <v-combobox
                      v-model="profileCategory.values"
                      :items="getCategorySelection()"
                      item-text="id"
                      item-value="id"
                      multiple
                      chips
                    ></v-combobox>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </transition-group>
      </draggable>
    </v-expansion-panels>
  </v-col>
</template>

<script>
  import { v4 as uuidv4 } from 'uuid';
  import draggable from 'vuedraggable';
  import * as helpers from '../shootingProgramHelpers.js';

  export default {
    name: 'EditProfilePanel',

    props: {
      defaultProfileName: Object,
      profiles: {
        default: () => [],
        type: Array,
      },
    },

    data: () => ({
      profileList: [],
    }),

    watch: {
      profiles: function (newVal) {
        if (newVal.length != this.profileList.length) this.profileList = newVal;
      },
    },

    created() {
      this.profileList = this.profiles;
    },

    components: {
      draggable,
    },

    methods: {
      getCategoryClass() {
        return helpers.getCategoryClass();
      },

      getCategorySelection() {
        return helpers.getCategorySelection();
      },

      onAddProfile() {
        this.profiles.push({
          id: uuidv4(),
          name: {
            value: '',
          },
          categories: [],
        });
      },

      onAddProfileCategory(id) {
        for (let i = 0; i < this.profiles.length; i++) {
          if (this.profiles[i].id == id) {
            this.profiles[i].categories.push({});
          }
        }
      },
      onDragProfileEnd() {
        this.$emit('onDragProfileEnd', this.profileList);
      },
      onDeleteProfile(id) {
        this.$emit('onDeleteProfile', id);
      },
      onDeleteProfileCategory(index, profileIndex) {
        this.$emit('onDeleteProfileCategory', { categoryLocation: index, profileLocation: profileIndex });
      },
    },
  };
</script>
